export const EMPTY_STORE_ID = 'EMPTY_STORE_ID'
export const CUSTOM_STORE_ID = 'CUSTOM_STORE_ID'